import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';



export function getPreguntasFrecuentesListSuccess(preguntasfrecuentes) {
  return {type: types.LOAD_PREGUNTASFRECUENTES_LIST_SUCCESS, preguntasfrecuentes};
}



export function getPreguntasFrecuentesList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PreguntasFrecuentesApi.getPreguntasFrecuentesList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(preguntasfrecuentes => {                  
                  dispatch(getPreguntasFrecuentesListSuccess(preguntasfrecuentes));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getPreguntasFrecuentesSuccess(catalogo) {
  return {type: types.LOAD_PREGUNTASFRECUENTES_SUCCESS, catalogo};
}

export function getPreguntasFrecuentes(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().PreguntasFrecuentesApi.getPreguntasFrecuentes(id, token).then(preguntasfrecuentes => {   
        dispatch(getPreguntasFrecuentesSuccess(preguntasfrecuentes));
        return preguntasfrecuentes;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(preguntasfrecuentes) {
  return {type: types.SAVE_PREGUNTASFRECUENTES_SUCCESS, preguntasfrecuentes};
}


export function save(preguntasfrecuentes, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().PreguntasFrecuentesApi.save(preguntasfrecuentes, token).then(preguntasfrecuentesGuardado => {   
    dispatch(saveSuccess(preguntasfrecuentesGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getPreguntasFrecuentesComboSuccess(datos) {
  return {type: types.GET_PREGUNTASFRECUENTESS_COMBO_SUCCESS, datos};
}

export function getPreguntasFrecuentesCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().PreguntasFrecuentesApi.getPreguntasFrecuentesCombo(token).then(datos => {   
        
      dispatch(getPreguntasFrecuentesComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(preguntasfrecuentes) {
  return {type: types.BORRAR_PREGUNTASFRECUENTES_SUCCESS, preguntasfrecuentes};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PreguntasFrecuentesApi.borrar(id, token ).then(preguntasfrecuentes => {
               
                  dispatch(borrarSuccess(preguntasfrecuentes));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(preguntasfrecuentes) {
  return {type: types.ACTIVAR_PREGUNTASFRECUENTES_SUCCESS, preguntasfrecuentes};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PreguntasFrecuentesApi.activar(id, token).then(preguntasfrecuentes => {
               
                  dispatch(activarSuccess(preguntasfrecuentes));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_PREGUNTASFRECUENTES, filtro};
}



